export default __webpack_public_path__ + "3a7e185ea1ca1db8cc34c10b4816c1a1.svg";